module.exports = __webpack_public_path__ + "img/wp__logo.a48b4b91.png";